import { ReactNode } from 'react';
import { Radio } from 'ui/radio';
import { spacing } from 'ui/theme';

type Props = {
  id: string;
  isChecked: boolean;
  label: string | ReactNode;
  onClick: (e: { target: { value: string } }, { value }: { value: string }) => void;
  value: string;
};

export const StyledRadio = ({ isChecked, onClick, label, value, id, ...props }: Props) => {
  const handleClick = () => onClick({ target: { value } }, { value });

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: spacing.half }}>
      <Radio id={id} isChecked={isChecked} onClick={handleClick} value={value} {...props} />
      {typeof label === 'string' ? (
        <label htmlFor={id} onClick={handleClick} style={{ margin: 0, cursor: 'pointer' }}>
          {label}
        </label>
      ) : (
        label
      )}
    </div>
  );
};
